/**
 * Deep links into /help. Every heading in the guide gets an id from its text,
 * and a page's "?" opens the part about that page, so explanations live in
 * one place instead of under each page title.
 */

/** The id a help heading gets: "Demand lifecycle & stages" → "demand-lifecycle-stages". */
export function helpSlug(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
}

/** Where each page's "?" leads. A test checks each one is a heading in the guide. */
export const HELP_ANCHORS = {
  opportunities: 'browsing-opportunities',
  profile: 'managing-your-profile-skills',
  submissions: 'asking-for-something',
  auditQueue: 'demands-people-submit-the-audit-queue',
  sentToDsai: 'sent-to-dsai',
  demandList: 'browsing-the-demand-list',
  kanban: 'movement-is-free',
  stages: 'demand-lifecycle-stages',
  talentDirectory: 'inviting-talent',
  comments: 'comments-are-permanent',
  focusArea: 'keeping-up-with-a-focus-area',
} as const

export type HelpTopic = keyof typeof HELP_ANCHORS
